import { RootState } from "../../redux/reducers";
import { store } from "../../redux/store";
import httpService from "../httpService";
import { CreateProductDto, PaymentLinkDto, ProductDto, UpdateProductDto } from "../../models/marketplace.model";

export async function createProduct(createProductDto: CreateProductDto): Promise<ProductDto> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if(!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .post<ProductDto>(`/marketplace/products/${selectedDashboard}`, createProductDto)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function updateProduct(productId: string, updateProductDto: UpdateProductDto): Promise<ProductDto> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if(!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }   
    return httpService
        .put<ProductDto>(`/marketplace/products/${selectedDashboard}/${productId}`, updateProductDto)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function deleteProduct(productId: string): Promise<void> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if(!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .delete(`/marketplace/products/${selectedDashboard}/${productId}`)
        .then(() => {})
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getProducts(): Promise<ProductDto[]> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if(!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<ProductDto[]>(`/marketplace/products/${selectedDashboard}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getPaymentLink(productId: string): Promise<PaymentLinkDto> {
    return httpService
        .get<PaymentLinkDto>(`/marketplace/products/${productId}/payment-link`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}
